// Author THQ
// Date 2025-04-08 17:07:36

class PpeApplyScrapDetail {
    constructor({
                    id = null,
                    flowId = '',
                    inventoryId = '',
                    itemType = '',
                    itemName = '',
                    itemModel = '',
                    itemUnit = '',
                    originalQuantity = '',
                    applyQuantity = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.flowId = flowId;
        this.inventoryId = inventoryId;
        this.itemType = itemType;
        this.itemName = itemName;
        this.itemModel = itemModel;
        this.itemUnit = itemUnit;
        this.originalQuantity = originalQuantity;
        this.applyQuantity = applyQuantity;
        this.remark = remark;
    }
}

function newEntity() {
    return new PpeApplyScrapDetail();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'flowId',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.flowId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'inventoryId',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.inventoryId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemType',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.itemType',
            sortable: true,
            form: {
                type: 'dictEnumSelect',
                modalMultiSelectedType: 'string'
                , entity: 'ppe_material_type'
            }
        },
        {
            key: 'itemName',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.itemName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemModel',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.itemModel',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'itemUnit',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.itemUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'originalQuantity',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.originalQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'applyQuantity',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.applyQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.ppe.ppeApplyScrapDetail.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    flowIdFilter: '',
    inventoryIdFilter: '',
    itemTypeFilter: '',
    itemNameFilter: '',
    itemModelFilter: '',
    itemUnitFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'flowIdFilter',
        label: 'label.em.ppe.ppeApplyScrapDetail.filter.flowId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppeApplyRecord'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inventoryIdFilter',
        label: 'label.em.ppe.ppeApplyScrapDetail.filter.inventoryId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppeInventory'
            , correspondingField: 'id'
        }
    },
    {
        key: 'itemTypeFilter',
        label: 'label.em.ppe.ppeApplyScrapDetail.filter.itemType',
        disabled: false,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppe_material_type'
        }
    },
    {
        key: 'itemNameFilter',
        label: 'label.em.ppe.ppeApplyScrapDetail.filter.itemName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemModelFilter',
        label: 'label.em.ppe.ppeApplyScrapDetail.filter.itemModel',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemUnitFilter',
        label: 'label.em.ppe.ppeApplyScrapDetail.filter.itemUnit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'flowId',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.flowId',
        sortable: true,
        isDetail: true,
        disabled: true,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppeApplyRecord'
            , correspondingField: 'id'
        }
    },
    {
        key: 'inventoryId',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.inventoryId',
        sortable: true,
        isDetail: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemType',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.itemType',
        sortable: true,
        disabled: true,
        form: {
            type: 'dictEnumSelect',
            modalMultiSelectedType: 'string'
            , entity: 'ppe_material_type'
        }
    },
    {
        key: 'itemName',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.itemName',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            ,
            required: true
            ,
            entity: 'ppeInventory'
            ,
            correspondingField: 'itemName'
            ,
            fieldsBindingByEntityModalSelected: '{"inventoryId":"id","itemModel":"itemModel","itemUnit":"itemUnit","originalQuantity":"quantity","itemType":"itemType"}'
        }
    },
    {
        key: 'itemModel',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.itemModel',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'itemUnit',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.itemUnit',
        sortable: true,
        disabled: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'originalQuantity',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.originalQuantity',
        sortable: true,
        disabled: true,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'applyQuantity',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.applyQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'remark',
        label: 'label.em.ppe.ppeApplyScrapDetail.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
]

export {
    PpeApplyScrapDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
